import _pt from 'prop-types';
import 'react';
import { jsx, Global } from '@emotion/core';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import { withStores } from "../contexts/StoresContext.js";

var SignedSuccessModal = function SignedSuccessModal(_ref) {
  var isOpen = _ref.isOpen,
      _ref$redirectButton = _ref.redirectButton,
      RedirectButton = _ref$redirectButton === void 0 ? function () {
    return null;
  } : _ref$redirectButton,
      onClose = _ref.onClose,
      modalHeaderText = _ref.modalHeaderText,
      _ref$modalBodyContent = _ref.modalBodyContent,
      ModalBodyContent = _ref$modalBodyContent === void 0 ? function () {
    return null;
  } : _ref$modalBodyContent;
  return jsx(Modal, {
    isOpen: isOpen,
    backdrop: true,
    zIndex: "10050",
    className: "js-signed-success-modal"
  }, jsx(Global, {
    styles: {
      '.modal': {
        zIndex: 10050
      }
    }
  }), jsx(ModalHeader, {
    toggle: onClose
  }, modalHeaderText), jsx(ModalBody, null, jsx(ModalBodyContent, null)), jsx(ModalFooter, null, jsx(RedirectButton, null)));
};

SignedSuccessModal.displayName = "SignedSuccessModal";
SignedSuccessModal.propTypes = {
  isOpen: _pt.bool.isRequired,
  onClose: _pt.func.isRequired,
  modalHeaderText: _pt.string,
  children: _pt.node
};
var SignedSuccessModal$1 = withStores(observer(SignedSuccessModal));
export default SignedSuccessModal$1;